import React, { Component } from 'react';
import SandboxItemContainer from './SandboxItemContainer';
import TransactionService from '../../../service/TransactionService';
import { ServiceNames } from '../../../constant/ServiceNames';
import ServiceContainer from '../../../config/ServiceContainer';
import CustomLoading from '../../custom/CustomLoading';
import { RootState } from '../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { clearHistories, setHistories, setHistoryDate } from '../../../redux/actions/SandboxActions';
import { SandboxHistorySchema } from '../../../domain/stream/transaction/TransactionDomains';
import { Calendar, CalendarChangeParams } from 'primereact/calendar';
import LanguageUtil from '../../../util/LanguageUtil';
import moment from 'moment';

class SandboxHistoryContainer extends Component<Props, State> {
  public state = new State();

  private readonly transactionService: TransactionService = ServiceContainer.getInstance().get(ServiceNames.CHANNEL);

  render() {
    const { loading } = this.state;
    const {
      sandbox: { histories, historyDate },
      setHistory,
    } = this.props;
    if (histories == undefined) return <></>;
    if (loading) return <CustomLoading />;

    return (
      <div className={'flex flex-col w-full gap-y-4 px-5'}>
        <span className={'flex w-full !h-[35px] border-[1px] border-[#E0E4E8] rounded-lg items-center'}>
          <Calendar
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.startDateFilter', defaultMessage: 'Start Date Filter' })}
            className={'!h-[34px] w-full'}
            onChange={(e: CalendarChangeParams) => this.onChangeDate(e)}
            value={historyDate}
          >
            {' '}
          </Calendar>
        </span>
        <div className={'flex border-t flex-col first:border-t-[1px] first:border-[#EAECF0] overflow-y-scroll max-h-[calc(100dvh-350px)] custom-scroll'}>
          <SandboxItemContainer setHistory={setHistory} histories={histories.pinned} label={LanguageUtil.get({ id: 'common.label.pinned', defaultMessage: 'PINNED' })} />
          <div className={'text-md text-[#9CA3AF] py-2  border-b-[1px]'}>{LanguageUtil.get({ id: 'common.label.all', defaultMessage: 'ALL' })}</div>
          {Object.keys(histories.histories)
            ?.sort((a, b) => moment(b, 'DD-MM-YYYY').valueOf() - moment(a, 'DD-MM-YYYY').valueOf())
            ?.map((date, index) => (
              <SandboxItemContainer key={index} label={date} setHistory={setHistory} histories={histories.histories[date]} />
            ))}
        </div>
      </div>
    );
  }

  public async componentDidMount() {
    await this.getHistories();
  }

  public componentWillUnmount() {
    const { clearHistories } = this.props;
    clearHistories();
  }

  public async componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    if (prevProps.sandbox.historyDate !== this.props.sandbox.historyDate) {
      await this.getHistories();
    }
  }

  private onChangeDate = async (e: CalendarChangeParams) => {
    const { setHistoryDate } = this.props;
    setHistoryDate(e.value as string);
  };

  public async getHistories() {
    const {
      setHistories,
      sandbox: { historyDate },
    } = this.props;
    this.setState({ loading: true });
    const history = await this.transactionService.getHistory(historyDate as string);
    setHistories(history);
    this.setState({ loading: false });
  }
}

class State {
  loading: boolean = false;
}

interface Props extends ReduxProps {
  setHistory: (history: SandboxHistorySchema) => void;
}

const mapStateToProps = (state: RootState) => ({
  sandbox: state.sandbox,
});
const mapDispatchToProps = { setHistories, clearHistories, setHistoryDate };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(SandboxHistoryContainer);
